import $ from "jquery"

// smooth animate link
$(function(){
  const $link = $('.js-link')

  $link.on('click', function(e) {
    e.preventDefault()

    const speed = 500
    const href = $(this).attr("href")
    const target = $(href == "#" || href == "" ? 'html' : href)
    const position = target.offset().top
    const headerHeight = $('#js-spMenu').outerHeight()
    const movePos = position - headerHeight

    $("html, body").animate({scrollTop:movePos}, speed, "swing")
    return false
  })
})

// switch tab
$(function() {
  const $tab = $('.js-tab'), $step = $('.js-step')

  $tab.on('click', function() {
    const index = $tab.index(this)

    $tab.removeClass('is-active')
    $(this).addClass('is-active')

    $step.removeClass('is-active')
    $step.eq(index).addClass('is-active')
  })
})

// kv form validation（LP お問い合わせ: 複数フォーム同一ロジック）
$(function() {
  const initKvForm = ($form) => {
    const $requiredFields = $form
      .find('input[required], select[required]')
      .not('[type="checkbox"]')
    const $privacyCheck = $form.find('input[type="checkbox"][name="privacy_check"]')
    const $submit = $form.find('.c-submit')

    const toggleSubmitState = () => {
      const allFilled = $requiredFields.toArray().every((el) => {
        const $el = $(el)
        const val = $el.val()
        if ($el.is('select')) {
          return val !== '' && val != null
        }
        return String(val || '').trim() !== ''
      })
      const agreed = $privacyCheck.prop('checked')
      const canSubmit = allFilled && agreed

      $submit.prop('disabled', !canSubmit)
      $submit.toggleClass('is-active', canSubmit)
    }

    $requiredFields.on('input change', toggleSubmitState)
    $privacyCheck.on('change', toggleSubmitState)

    $form.on('submit', (e) => {
      if ($submit.prop('disabled')) {
        e.preventDefault()
      }
    })

    toggleSubmitState()
  }

  ['#c-kv__form', '#c-kv__form2'].forEach((selector) => {
    const $form = $(selector)
    if ($form.length) initKvForm($form)
  })
})
